export enum ORDER_BY_VALUE {
  'ASC' = 'ASC',
  'DESC' = 'DESC',
}

export const CONST_ORDER_BY_VALUE = Object.values(ORDER_BY_VALUE);
